import {
  Box,
  Button,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  verifyPANOnGrid,
  saveCurrentAddress,
  verifyPin,
} from "../../services/authenticationService";
import ErrorModal from "../common/ErrorModal";
import CAlert from "../utils/CAlert";
import CInput from "../utils/CInput";
import { setAppLoader } from "../../actions/setAppLoader";
import VerifiedIcon from "@mui/icons-material/Verified";
import useMediaQuery from "@mui/material/useMediaQuery";
import CurrentAddressV1 from "./CurrentAddress";


export default function PANValidationAndAdditionalAddressPage(props) {
  const navigate = useNavigate();
  const { userId } = props;
  const [errorMsg, setErrorMsg] = React.useState("");
  const [pinCode, setPinCode] = React.useState();
  const [pinCodeVerified, setpinCodeVerified] = React.useState(false);
  const [panNumber, setPanNumber] = React.useState();
  const [panNumberVerified, setPanNumberVerified] = React.useState(false);
  const [userAddressData, setUserAddressData] = React.useState();
  const [currentUserAddressData, setCurrentUserAddressData] = React.useState();
  const [locationError, setLocationError] = React.useState(false);
  const userDetailsId = localStorage.getItem("detailId");
  const [error, setError] = React.useState(false);
  const [invalidPanCount, setInvalidPanCount] = React.useState(0);
  const [technicalError, setTechnicalError] = React.useState(false);
  // const [openDecl, setOpenDecl] = React.useState(true)

  const dispatch = useDispatch();

  async function onPinVerifyClick(e) {
    setPinCode(e);
    if(!e || e.length < 6) {
      setpinCodeVerified(false);
      return;
    }
    dispatch(setAppLoader(true));
    verifyPin(e).then((data) => {
      if (data.status === 200 || data.status === 201) {
        setpinCodeVerified(true);
      } else if (data.response.status === 400) {
        setpinCodeVerified(false);
      } else if (data.response.status === 451) {
        setpinCodeVerified(false);
        setLocationError(true);
      }
    });

    dispatch(setAppLoader(false));
  }


  async function onPanVerifyClick(e) {
    e.preventDefault();
    if (!panNumber || panNumber.length < 10) {
      setError(true);
      setErrorMsg("Please Enter Valid PAN Number");
      return;
    }
    dispatch(setAppLoader(true));
    const obj = {
      pan: panNumber,
      userId: userId,
      doDedupe: false
    };

    await verifyPANOnGrid(obj).then(async (apiData) => {
      console.log("verifyPANOnGrid>>>", apiData);
      const data = apiData?.data;
      if (
        (data?.response?.panStatus === "SUCCESS" || data?.response?.panStatus === "SKIPPED") &&
        (data?.response?.dedupeStatus === "SUCCESS" || data?.response?.dedupeStatus === "SKIPPED")
      ) {
        setError(false);
        setErrorMsg(null);
        setUserAddressData(data?.response?.panData?.address_data);
        setInvalidPanCount(0);
        setPanNumberVerified(true);
        
      } else if (data?.response?.dedupeStatus === "FAILURE") {
        setErrorMsg("Existing Customer. Kindly Login!");
        setPanNumberVerified(false);
      } else {
        console.log(invalidPanCount);
        setError(true);
        setErrorMsg("Invalid PAN, please try again");
        setInvalidPanCount(invalidPanCount + 1);
      }
    });
    dispatch(setAppLoader(false));
  }

  function onCurentAddressChange(userAddress, isValid) {
    setCurrentUserAddressData(userAddress);
    setpinCodeVerified(isValid);  
  }

  async function saveDetailsAndContinue(e) {
    e.preventDefault();
    dispatch(setAppLoader(true));
   if(!pinCodeVerified) {
      await onPinVerifyClick(pinCode);
      if(!pinCodeVerified) {
        return;
      }
   }
    const obj = {
      userId: userId,
      detailId: userDetailsId,
      userAddress: currentUserAddressData,
    };
    console.log(obj);
    saveCurrentAddress(obj).then((data) => {
      console.log(data?.data);
      navigate("/personalDetails", { state: { tabValue: 4, stepperCount: 4, userDetailId: userDetailsId || localStorage.getItem('detailId') } })
    });
    
  }
  const isMobile = useMediaQuery("(max-width:600px)");


  return (
    <form
      onSubmit={(e) => saveDetailsAndContinue(e)}
      className="applicationFormContainer"
    >
      {error ? (
        <CAlert open={error} message={errorMsg} severity="error" />
      ) : null}
      {errorMsg === "Data Saved Successfully" ? (
        <CAlert open={true} message={errorMsg} severity="success" />
      ) : null}
      <Typography
        color="textColor"
        variant="subtitle2"
        sx={{ textAlign: "start", fontWeight: "bold" }}
      >
        PAN Validation
      </Typography>


      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
       
        <Grid item xs={12} sm={6}>
          <Box className="form" sx={{ mt: 1 }}>
            <CInput
              type="text"
              helperText="Invalid PAN, please try again"
              isError={error ? true : false}
              maxLength={10}
              name="phone"
              value={panNumber}
              onChange={(e) => setPanNumber(e.toUpperCase())}
              label="PAN*"
              disabled={panNumberVerified}
              subtitle="Enter PAN number and click verify to initiate PAN verification."
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box
            sx={{
              padding: isMobile ? "0px 0px 0px" : "90px 0px 0px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Button
                type="button"
                sx={{ fontStyle: "Lato" }}
                color="neutral"
                disabled={!panNumber || panNumberVerified}
                variant="outlined"
                onClick={(e) => onPanVerifyClick(e)}
              >
                Verify PAN Number
              </Button>
          </Box>
        </Grid>
        {panNumberVerified && (
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                mt: 1,
                alignItems: "center",
              }}
            >
              <VerifiedIcon
                style={{ color: "green", fontSize: "22px", marginTop: "5px" }}
              />
              <Typography
                color="textColorR"
                variant="subtitle1"
                sx={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  fontFamily: "lato",
                  marginLeft: "10px",
                }}
              >
                PAN Verified!
              </Typography>
            </Box>
          </Grid>
        )}

<Grid item>
 <CurrentAddressV1 userAddressData={userAddressData} onPinChange={onCurentAddressChange}/>
</Grid>
       
 
      </Grid>
      <div
        style={{
          padding: "20px 0px 0px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Button
          sx={{ fontStyle: "Lato" }}
          color="neutral"
          variant="outlined"
          onClick={() => navigate(-1)}
          style={{ marginRight: "10px" }}  
        >
          Back
        </Button> 
        <Button
          type="submit"
          sx={{ fontStyle: "Lato" }}
          color="neutral"
          variant="contained"
          disabled={!panNumberVerified || !pinCodeVerified || !(currentUserAddressData?.city) || !(currentUserAddressData?.line_1)}
        >
          Save & Continue
        </Button>
      </div>
      {locationError && (
        <ErrorModal open={locationError} setOpen={setLocationError} />
      )}
      {technicalError && (
        <ErrorModal
          open={technicalError}
          setOpen={setTechnicalError}
          isTechnicalError={true}
        />
      )}
    </form>
  );
}
